"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.bulkUpload.files.successProcessing': '您的 {count} 个文件将在后台处理并添加到您的知识库中。',
    'knowledge.bulkUpload.files.partialSuccess': '{successCount} 个文件将在后台处理，{errorCount} 个失败。',
    'knowledge.bulkUpload.files.allFailed': '所有 {count} 个文件上传失败。',
    'knowledge.bulkUpload.googleDrive.successProcessing': 'Google Drive目录 "{directoryName}" 将在后台处理并添加到您的知识库中。',
};
